module.exports = ".field {\r\n    display: inline-block;\r\n    margin-right: 20px;\r\n}"